import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.602 2.102a2.35 2.35 0 0 1 2.796 0l7.4 5.482c.599.443.952 1.144.952 1.888V20.4a2.35 2.35 0 0 1-2.35 2.35H4.6a2.35 2.35 0 0 1-2.35-2.35V9.472c0-.744.353-1.445.951-1.888zm1.904 1.206a.85.85 0 0 0-1.012 0l-7.4 5.482a.85.85 0 0 0-.344.682V20.4c0 .47.38.85.85.85h3.65V16.6a2.35 2.35 0 0 1 2.35-2.35h2.8l.24.011a2.35 2.35 0 0 1 2.11 2.338v4.65h3.65c.47 0 .85-.38.85-.849V9.472a.85.85 0 0 0-.344-.682zM10.6 15.75a.85.85 0 0 0-.85.85v4.65h4.5V16.6a.85.85 0 0 0-.763-.847l-.087-.003z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }